import { render } from "./FourthSection.vue?vue&type=template&id=8dc3f858&scoped=true"
import script from "./FourthSection.vue?vue&type=script&lang=js"
export * from "./FourthSection.vue?vue&type=script&lang=js"

import "./FourthSection.vue?vue&type=style&index=0&id=8dc3f858&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc3f858"]])

export default __exports__